import React from "react";

const testimonials = [
  {
    title: "The best service I've ever used! Highly recommended.",
    client: "John Doe",
    clientInfo: "CEO @CompanyX",
    img: "/path/to/john-image.jpg",
  },
  {
    title: "Incredible experience and amazing customer support.",
    client: "Jane Smith",
    clientInfo: "Software Engineer @TechCorp",
    img: "/path/to/jane-image.jpg",
  },
  {
    title: "Their product helped me take my business to the next level.",
    client: "Robert Lee",
    clientInfo: "Entrepreneur @StartUpInc",
    img: "/path/to/robert-image.jpg",
  },
];

function Memberspeak() {
  return (
    <div>
      <br /><br /><br />
      <header className="text-black text-center pt-30 py-25">
        <h1 className="display-4">Our Member's Testimonials</h1>
      </header>
      <main>
        <section className="container py-5">
          <h2 className="text-center mb-5">What Our Members Say</h2>
          <div className="row justify-content-center">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div className="card shadow-lg h-100 border-0 hover-shadow">
                  <div className="card-body">
                    <h5 className="card-title text-primary">"{testimonial.title}"</h5>
                    <div className="d-flex align-items-center">
                      <img
                        src={testimonial.img}
                        alt={`${testimonial.client}'s profile`}
                        className="rounded-circle me-3"
                        style={{
                          width: "4rem",
                          height: "4rem",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Memberspeak;
